<template>
 <app-modal v-model="isDialogOpened"
            size="xs"
            :ok-text="$t('project.documents.dialogs.DocumentsRenameDialog.rename')"
            :ok-loading="renameSavedChecklistPending"
            :ok-disabled="nameErrors.length > 0 || renameSavedChecklistPending"
            :cancel-disabled="renameSavedChecklistPending"
            @cancel="prepareCloseRenameSavedChecklist"
            @ok="prepareRenameSavedChecklist"
 >
   <template #title>
      {{ $t('project.checklist.dialogs.SavedChecklistRenameDialog.title') }}
   </template>
   <template #body>
     <form @submit.prevent="prepareRenameSavedChecklist"
     >
       <AppTextField v-model.trim="v$.newName.$model"
                     class="required"
                     :label="$t('project.documents.dialogs.DocumentsRenameDialog.lblRenameDocument')"
                     :counter="nameMaxLength"
                     :maxlength="nameMaxLength"
                     :error-messages="nameErrors"
                     autofocus
       />
     </form>
   </template>
 </app-modal>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { mapActions, mapState } from 'vuex'

import AppTextField from '@/common/AppTextField.vue'
import { formFieldErrors } from '@/common/utils/form'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { RENAME_SAVED_CHECKLIST } from '@/store/modules/checklist/action_types'

const NAME_MAX_LENGTH = 100

export default {
  name: 'SavedChecklistRenameDialog',
  components: {
    AppTextField,
  },
  mixins: [dialogMixin],
  setup: () => ({ v$: useVuelidate() }),
  validations: {
    newName: {
      required,
      maxLength: (value, vm) => value.length <= vm.nameMaxLength,
    },
  },
  props: {
    checklist: {
      required: true,
      validator: (value) => {
        return value === null || typeof value === 'object'
      },
    },
  },
  data () {
    return {
      newName: '',
    }
  },
  computed: {
    ...mapState('checklist', ['renameSavedChecklistPending']),
    nameMaxLength () {
      return NAME_MAX_LENGTH
    },
    nameErrors () {
      return formFieldErrors(
        this.v$.name,
        [
          ['required', this.$t('common.validations.fieldRequired', { fieldName: this.$t('project.checklist.dialogs.SaveChecklistDialog.saveName') })],
          ['maxLength', this.$t('common.validations.maxLength', { fieldName: this.$t('project.checklist.dialogs.SaveChecklistDialog.saveName') })],
        ],
      )
    },
  },
  created () {
    this.newName = this.checklist.name
  },
  methods: {
    ...mapActions('checklist', [RENAME_SAVED_CHECKLIST]),
    prepareCloseRenameSavedChecklist () {
      this.closeDialog()
    },
    async prepareRenameSavedChecklist () {
      this.v$.$touch()
      if (!this.v$.$invalid) {
        try {
          await this.RENAME_SAVED_CHECKLIST({
            todoListId: this.checklist.id,
            name: this.newName,
          })
          toast.success(this.$t('project.checklist.dialogs.SavedChecklistRenameDialog.renameSavedChecklistSuccess'))
          this.checklist.name = this.newName
          this.newName = ''
        } catch (e) {
          toast.error(this.$t('project.checklist.dialogs.SavedChecklistRenameDialog.renameSavedChecklistError'))
        } finally {
          this.closeDialog()
        }
      }
    },
  },
}
</script>
